import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery, Button } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const PaypalCaption = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("span", {
        className: "pay-pal-caption"
    }, getLabel('checkout.express.apple.pay.action.payWith'), /*#__PURE__*/ React.createElement(Icon, {
        name: "paypal-checkout-button-icon",
        viewBox: "0 0 77 22",
        width: 77,
        height: 22
    }));
};
const PaypalButton = ({ onClick , isDisabled =false  })=>{
    const caption = /*#__PURE__*/ React.createElement(PaypalCaption, null);
    const breakPoint = MediaQuery.useBreakpoint();
    return /*#__PURE__*/ React.createElement(Button, {
        disabled: isDisabled,
        size: breakPoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ? 'small' : undefined,
        className: "cart-navigation__button pay-pal",
        "data-t": "paypal-pay-action",
        caption: caption,
        onClick: onClick
    });
};
const AdyenPaypalActionButton = (props)=>{
    return /*#__PURE__*/ React.createElement(PaypalButton, swcHelpers.extends({}, props));
};

export { AdyenPaypalActionButton };
//# sourceMappingURL=AdyenPaypalActionButton.js.map
